// Per-conversation participant directory, keyed by bare external user id (the
// `U…` part of a Slack `<@U087>` mention). Drives the mention chips markstream
// renders via the custom `<mention>` component.
//
// Module-level reactive singleton: the controlplane returns a `participants` map
// on GET /v1/api/conversations/{id} (conversation meta); the host view calls
// setParticipants(meta.participants) after the fetch, and Mention.vue reads
// participants.value[id]. Kept module-global (one open conversation at a time)
// because markstream owns the message-body render tree and there's no clean prop
// path to a custom node component. Reset on conversation switch so a stale
// directory can't bleed across threads.
import { ref } from 'vue';

export interface Participant {
  name?: string;
  /** Same-origin avatar URL (Trove-proxied); external hosts dropped upstream. */
  avatar_url?: string;
}

/** Reactive id -> participant map for the OPEN conversation. Mention reads this
 *  directly, so a late meta fetch (or a reset) re-renders already-rendered chips. */
export const participants = ref<Record<string, Participant>>({});

/** Replace the participants map for the open conversation. Tolerant of
 *  null/garbage - a missing/odd value just clears the map. */
export function setParticipants(m: unknown): void {
  participants.value =
    m && typeof m === 'object' ? (m as Record<string, Participant>) : {};
}
